var html = document.documentElement;
var body = document.body;

video();
table();
burger();

function video() {
    'use strict';
    const sources = [
        '.single-content iframe[src*="youtube.com"]',
        '.single-content iframe[src*="youtube-nocookie.com"]',
        '.single-content iframe[src*="player.vimeo.com"]',
        '.single-content iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed',
    ];

    reframe(document.querySelectorAll(sources.join(',')));
}

function table() {
    'use strict';
    if (
        !body.classList.contains('post-template') &&
        !body.classList.contains('page-template')
    )
        return;

    var tables = document.querySelectorAll('.single-content .table');

    tables.forEach(function (table) {
        var labels = [];

        table.querySelectorAll('thead th').forEach(function (label) {
            labels.push(label.textContent);
        });

        table.querySelectorAll('tr').forEach(function (row) {
            row.querySelectorAll('td').forEach(function (column, index) {
                column.setAttribute('data-label', labels[index]);
            });
        });
    });
}

function burger() {
    'use strict';
    document.querySelector('.burger').addEventListener('click', function () {
        if (!body.classList.contains('menu-opened')) {
            body.classList.add('menu-opened');
        } else {
            body.classList.remove('menu-opened');
        }
    });
}

/*
Adjust footer link scroll offset to compensate for fixed header navigation bar
*/

$(document).ready(function () {
    // Adjust scroll for footnote links
    $('a[href^="#fn"]:not([href^="#fnref"])').click(function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        var href = $(this).attr('href');
        var targetElement = $(href);

        if (targetElement.length) {
            var offsetTop = targetElement.offset().top - 100;
            $('html, body').animate({ scrollTop: offsetTop }, 'smooth');
        }
    });

    // Adjust scroll for footnote back-reference links
    $('a[href^="#fnref"]').click(function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        var href = $(this).attr('href');
        var targetElement = $(href);

        if (targetElement.length) {
            var offsetTop = targetElement.offset().top - 200; // Adjust by 100px upwards
            $('html, body').animate({ scrollTop: offsetTop }, 'smooth');
        }
    });
});

function debounce(func, wait) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
    };
}

/*
Sidebar table of contents for the "Essay" pages
*/

$(document).ready(function () {
    if (!$('body').hasClass('tag-essay')) {
        return;
    }

    var headings = $('#single-content').find('h2, h3');

    // Exclude headings where the <!-- no toc --> flag is added.
    headings.each(function () {
        var heading = $(this);
        if (heading.html().indexOf('<!-- no toc -->') > -1) {
            heading.addClass('no-toc');
            heading.html(heading.html()?.replace('<!-- no toc -->', ''));
            heading.attr('id', heading.attr('id')?.replace('no-toc', ''));

            var link = heading.find('a').first();
            link.attr('href', link.attr('href')?.replace('no-toc', ''));
        }
    });

    headings = headings.not(function (index) {
        return $(this).hasClass('no-toc'); // This will remove elements with 'no-toc' class from the collection
    });

    var tocAccordionToggle = $(
        '<button id="toggle-inline-toc" class="toggle-inline-toc w-full text-left font-bold block border-2 p-3 sm:p-4 accordion-toggle text-lg mb-1">Show table of contents</button>'
    );
    var toc = $(
        '<div class="table-of-contents hidden"><h1 class="text-lg mb-1">Contents</h1></div>'
    );
    var map = {};

    function createTOC() {
        headings.each(function () {
            var heading = $(this);
            var id =
                heading.attr('id') ||
                heading.text().replace(/\s/g, '-').toLowerCase();
            heading.attr('id', id);

            var tocItem = $(
                '<a href="#' +
                    id +
                    '" class="toc-item block py-1 text-base hover:text-red-500 ' +
                    (heading.prop('tagName') === 'H3' ? 'pl-4' : '') +
                    '"></a>'
            ).text(heading.text());
            tocItem.click(function (e) {
                e.preventDefault();
                $('html, body').animate(
                    {
                        scrollTop: heading.offset().top - 100,
                    },
                    500
                );

                history.replaceState(null, null, '#' + id);
            });
            toc.append(tocItem);

            map[id] = tocItem;
        });

        toc.append('<hr class="mt-3 mb-3 border-b w-3">');

        var hasFootnotes = $('section.footnotes').length > 0;

        if (hasFootnotes) {
            toc.append(
                '<a href="#notes" class="toc-item toc-back-to-top block pb-0 text-base hover:active">Notes</a>'
            );
            toc.append('<hr class="mt-2 mb-3 border-b w-3">');
        }

        toc.append(
            `<a href="" class="toc-item toc-back-to-top block py-0 text-base hover:active" onclick="window.scrollTo(0,0); return false;"> Back to top <svg style="display: inline-block; margin-left: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke_width="2.5" stroke_linecap="round" stroke_linejoin="round">
    <line x1="12" y1="15" x2="12" y2="4"/>
    <line x1="12" y1="4" x2="8" y2="8"/>
    <line x1="12" y1="4" x2="16" y2="8"/>
</svg></a>`
        );

        $('section.footnotes').prepend(
            '<a id="notes" style="position: relative; top: -200px;"></a>'
        );
    }

    function positionTOC() {
        if ($(window).width() < 1358) {
            if (!$('#single-content').find(toc).length) {
                console.log('toc not already in content');
                $('#single-content').prepend(tocAccordionToggle);
                $('#single-content').prepend(toc); // Move TOC to the top of the content
                toc.removeClass(
                    'fixed top-24 pb-24 left-0 overflow-y-auto p-4 pl-8 h-screen'
                ).addClass('inline-toc hidden');

                tocAccordionToggle.click(function () {
                    toc.removeClass('hidden');
                    tocAccordionToggle.text('Show table of contents');
                    if (!toc.hasClass('hidden')) {
                        tocAccordionToggle.remove();
                    }
                });
            }
        } else {
            $('body').append(toc); // Keep TOC as sidebar
            $('#toggle-inline-toc').remove();
            toc.addClass(
                'fixed z-10 top-24 pb-32 left-0 h-screen overflow-y-auto p-4 pl-8'
            ).removeClass('inline-toc hidden');
        }
    }

    if (headings.length > 3) {
        createTOC();
        positionTOC();

        $(window).on(
            'resize',
            debounce(function () {
                positionTOC();
            }, 250)
        );

        $(window).on('scroll', function () {
            var scrollPosition = $(window).scrollTop();

            headings.each(function () {
                var currentHeading = $(this);
                var id = currentHeading.attr('id');

                if (currentHeading.offset().top <= scrollPosition + 100) {
                    $('.toc-item').removeClass('active'); // Remove highlight from all TOC items
                    map[id].addClass('active'); // Highlight the current section
                }
            });
        });
    }
});

/*
Right margin images for essay pages
*/

function findRightMarginImages() {
    var rightMarginImages = $('img[alt*="<!-- right margin -->"]');

    rightMarginImages.each(function () {
        var img = $(this);
        var figure = img.parent('figure');

        img.addClass('pull-right');
        img.attr(
            'alt',
            img.attr('alt').replace('<!-- right margin -->', '').trim()
        );

        if (figure) {
            figure.addClass('pull-right');
            var figCaption = figure.find('figcaption');
            if (figCaption) {
                figCaption.addClass('pull-right');
            }
        }
    });
}

function repositionRightMarginFigcaptions() {
    var rightMarginFigcaptions = $('figcaption.pull-right');

    if (window.innerWidth < 1358) {
        rightMarginFigcaptions.each(function () {
            var figCaption = $(this);
            figCaption.removeAttr('style');
        });
        return;
    }

    rightMarginFigcaptions.each(function () {
        var figure = $(this).parent('figure');
        var figCaption = $(this);
        var img = figure.find('img');
        if (img) {
            figCaption.css('margin-top', img.height() + 24 + 'px');
        }
    });
}

function enableRightMarginImageLightbox() {
    var rightMarginImages = $('img.pull-right');

    rightMarginImages.each(function () {
        $(this).featherlight($(this).attr('src'));
    });
}

$(document).ready(function () {
    if (!$('body').hasClass('tag-essay')) {
        return;
    }

    findRightMarginImages();
    enableRightMarginImageLightbox();
    repositionRightMarginFigcaptions();

    $(window).on('resize', function () {
        repositionRightMarginFigcaptions();
    });
});